import { BadgeStyled, BadgeVariant } from './Badge.styles';
import React from 'react';

interface Props {
  variant: BadgeVariant;
  'data-testid'?: string;
  text?: string;
  color?: string;
  'background-color'?: string;
  'border-color'?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  capitalize?: boolean;
  className?: string;
  width?: string;
}

export const Badge = ({
  variant,
  text,
  capitalize = false,
  ...props
}: Props) => {
  return (
    <BadgeStyled variant={variant} capitalize={capitalize} {...props}>
      {text}
    </BadgeStyled>
  );
};
